import AddNewAgentGroup from './AddNewAgentGroup';
import IvrProjectAgentGroupsListItem from './IvrProjectAgentGroupsListItem';

// @vue/component
export default {
  name: 'IvrProjectAgentGroupsList',

  components: {
    AddNewAgentGroup,
    IvrProjectAgentGroupsListItem,
  },

  props: {
    projectUuid: {
      type: String,
      default: null,
    },
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'client/project/agentsGroups/getList', 'client/project/agentsGroups/createGroup',
        'client/project/agentsGroups/removeGroup', 'client/project/agentsGroups/updateGroup',
      ]);
    },
    groupsList() {
      return this.$store.getters['client/project/agentsGroups/list'];
    },
  },

  created() {
    if (this.projectUuid) {
      this.$store.dispatch('client/project/agentsGroups/getList', this.projectUuid);
    }
  },
};
